
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-detach-part.html
riot.tag2('menu-item-detach-part',
  '<svg class="floating-menu_icon"> <use xlink:href="#detach-parts-icon"></use> </svg> <span class="floating-menu_label">Detach cards from whole</span>',
  '',
  'class="{opts.classes} floating-menu_item" onclick="{detachParts}"', function(opts) {
'use strict';

var _util = require('lib/util');

var _nodesUi = require('lib/nodes-ui');

var _menuUi = require('lib/menu-ui');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parent = this.parent;

var canvas = parent.opts.canvas;

this.detachParts = function () {
  var nodeIds = parent.getSelectedNodeIds();

  _nodesUi.nui.detachParts(nodeIds);
  parent.hide();

  _eventTracking2.default.track({
    category: (0, _util.getTrackingLabel)(parent),
    action: 'Detach cards',
    label: 'Selection'
  });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-detach-part')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-detach-part.html
// module id = 683
// module chunks = 0